import { render, staticRenderFns } from "./UknowAgencies.vue?vue&type=template&id=c60ddba0&scoped=true&"
import script from "./UknowAgencies.vue?vue&type=script&lang=ts&"
export * from "./UknowAgencies.vue?vue&type=script&lang=ts&"
import style0 from "./UknowAgencies.vue?vue&type=style&index=0&id=c60ddba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60ddba0",
  null
  
)

export default component.exports